import {
  Container as ChakraContainer,
  ContainerProps as ChakraContainerProps,
} from '@chakra-ui/react/container'
import { FC } from 'react'

interface IContainerProps extends ChakraContainerProps {
  maxMobileWidth?: string | number
}

export const Container: FC<IContainerProps> = ({
  maxMobileWidth = '480px',
  className,
  children,
  ...props
}) => {
  return (
    <ChakraContainer
      maxW={maxMobileWidth}
      mx="auto"
      px={4}
      className={className}
      {...props}
    >
      {children}
    </ChakraContainer>
  )
}
